import type { CurrencyInfo } from '@src/core/buyerApiClient';

import type { DetailedSaleItem } from '../types/saleItem';

export const getSaleItemPackageDiscountCents = (item: DetailedSaleItem): number =>
  Math.max(item.fullPriceCurrencyInfo.amountCents - item.totalPriceCurrencyInfo.amountCents, 0);

export const getSaleItemPackageDiscountCurrencyInfo = (item: DetailedSaleItem): CurrencyInfo => {
  const { fullPriceCurrencyInfo, totalPriceCurrencyInfo } = item;

  return {
    amountCents: fullPriceCurrencyInfo.amountCents - totalPriceCurrencyInfo.amountCents,
    currency: fullPriceCurrencyInfo.currency,
    originalAmountCents: fullPriceCurrencyInfo.originalAmountCents - totalPriceCurrencyInfo.originalAmountCents,
    originalCurrency: fullPriceCurrencyInfo.originalCurrency,
  };
};
